import type { Lang, TrackerItem } from '@/domain/content.types';

export interface DisplayName {
  /** The name to render in the active language. */
  value: string;
  /** The other language's name — shown as a subtitle or tooltip. */
  alt: string;
  /** True when Russian was requested but only the English name exists. */
  isFallback: boolean;
  /** True when the translation was machine-matched with low confidence. */
  needsReview: boolean;
}

/**
 * Pick the name to display.
 *
 * The alternate name always stays reachable. Fallout 76 players read English
 * wikis, datamining posts and trade listings, so a Russian-mode user still
 * needs the original name one hover (or one line) away.
 */
export function pickName(item: TrackerItem, lang: Lang): DisplayName {
  const isFallback = lang === 'ru' && item.i18n?.ruSource === 'fallback-en';
  return {
    value: item.name[lang],
    alt: lang === 'ru' ? item.name.en : item.name.ru,
    isFallback,
    needsReview: item.i18n?.needsReview === true && !isFallback,
  };
}
